<template>
  <button
    type="button"
    :disabled="isWished === null || isPending"
    @click="toggle(productId)"
  >
    <ArrowPathIcon
      v-if="isError"
      class="size-4 text-gray-400 transition-all duration-300 hover:scale-110"
      @click="toggle(productId)"
    />
    <VIconHeart
      v-else
      class="size-5 text-gray-400 transition-all duration-300 hover:scale-110"
      :fill="isWished ? 'currentColor' : 'white'"
      :class="{ 'animate-pulse-scale': isPending }"
    />
  </button>
</template>

<script setup>
import { ArrowPathIcon } from '@heroicons/vue/24/outline';
import { ref, watch } from 'vue';
import VIconHeart from '../../../../icons/VIconHeart.vue';
import useWishlistToggle from '../composables/useWishlistToggle';

const props = defineProps({
  wished: {
    type: Boolean,
    default: null,
  },
  productId: {
    type: Number,
    required: true,
  },
});

const isWished = ref(props.wished);

watch(() => props.wished, (value) => value !== null && (isWished.value = value));

const { toggle, isPending, isError } = useWishlistToggle(isWished);
</script>
